import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import AnimeList from "@/pages/anime/page";
import AnimeDetail from "@/pages/anime/detail/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import Search from "@/pages/search/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "anime", element: <AnimeList /> },
      { path: "anime/detail/:id", element: <AnimeDetail /> },
      { path: "news", element: <NewsList /> },
      { path: "news/detail/:id", element: <NewsDetail /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "search", element: <Search /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;